export const referenceDates = [
  { code: 'DocumentDate', name: 'Document date' },
  { code: 'LastTransitionDate', name: 'Last transition date' }
];
export const offerDocumentTypeId = -5;
